import { createApi, createDomain } from 'effector';

const domain = createDomain('viewMode');

export const $viewMode = domain.store<'mobile' | 'pc'>('pc');
export const $viewModeApi = createApi($viewMode, {
  mobile: () => 'mobile',
  pc: () => 'pc',
});

export const $viewModeDisplay = domain.store<boolean>(true);
export const $viewModeDisplayApi = createApi($viewModeDisplay, {
  show: () => true,
  hide: () => false,
});
